import {useSelector} from 'react-redux'
import {getNumberOfRooms} from 'modules/sapiSearch/selectors'
import {getIsMultiRoomBundlesSearch} from 'modules/search/selectors'

import {getNightlyPriceForAllRooms} from '@vio/core/src/price/business/price'

/**
 * Takes the nightly price of a single room and returns the combined nightly
 * price for all rooms in the search. When the search already returns an
 * all-rooms price (bundles), or there's only one room, it's returned unchanged.
 */
export const useNightlyForAllRooms = (hotelId: string) => {
  const numberOfRooms = useSelector(state => getNumberOfRooms(state, hotelId))
  const isMultiRoomBundlesSearch = useSelector(getIsMultiRoomBundlesSearch)

  return (nightly: number) =>
    getNightlyPriceForAllRooms(
      nightly,
      isMultiRoomBundlesSearch,
      numberOfRooms
    ) ?? nightly
}
